export function LogoMark({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true" focusable="false">
      <rect width="48" height="48" rx="13" fill="#0C1F38" />
      <path d="M14 35V25a10 10 0 0 1 20 0v10" fill="none" stroke="#FBF7F0" strokeWidth="3.6" strokeLinecap="round" />
      <circle cx="24" cy="12.5" r="3.4" fill="#D9A441" />
    </svg>
  );
}

export default function Logo({ light = false, testid = "header-logo" }) {
  return (
    <span className="flex items-center gap-3" data-testid={testid}>
      <LogoMark />
      <span className="leading-none">
        <span className={`block font-display text-xl font-semibold tracking-tight ${light ? "text-paper-warm" : "text-navy-900"}`}>
          Tonouh
        </span>
        <span className={`mt-1 block font-heading text-[10px] font-bold uppercase tracking-[0.32em] ${light ? "text-paper-warm/60" : "text-navy-900/55"}`}>
          Marketing
        </span>
      </span>
    </span>
  );
}
